
import PATINLogin from "./patin/pages/PATINLogin";
import PATINMentora from "./patin/pages/PATINMentora";
import PATINMeuPlano from "./patin/pages/PATINMeuPlano";

import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import HomePage from "./pages/HomePage";
import AceleracaoNFSB from "./pages/AceleracaoNFSB";
import ProgramaMakerIndustria from "./pages/ProgramaMakerIndustria";
import HubAcre from "./pages/HubAcre";
import HubAgenda from "./pages/HubAgenda";
import HubAdmin from "./pages/HubAdmin";
import PATINHome from "./patin/pages/PATINHome";
import PATINFormulario from "./patin/pages/PATINFormulario";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route
            path="/"
            element={<HomePage />}
          />

          <Route
            path="/aceleracaonfsb"
            element={<AceleracaoNFSB />}
          />

          <Route
            path="/programadomakeraindustria"
            element={<ProgramaMakerIndustria />}
          />
        
          <Route
            path="/hubacre"
            element={<HubAcre />}
          />
        
          <Route
            path="/hubacre/agenda"
            element={<HubAgenda />}
          />

          <Route
            path="/hubacre/admin"
            element={<HubAdmin />}
          />

          <Route
            path="/patin"
            element={<PATINHome />}
          />


          
          <Route path="/patin/login" element={<PATINLogin />} />
          <Route path="/patin/mentora" element={<PATINMentora />} />
          <Route path="/patin/meu-plano" element={<PATINMeuPlano />} />
<Route path="/patin/documento/:protocolo" element={<PATINFormulario />} />
          <Route
            path="/patin/iniciar"
            element={<PATINFormulario />}
          />

        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
